import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"plan-cards-wrapper\"><div class=\"card-header\"><h5>Transaction History</h5><div class=\"card-control plus\"><i class=\"plus iatse-icon-plus\"></i><span class=\"line\"></span></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CobraPayments = _resolveComponent("CobraPayments")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_CobraPayments, {
      cobraPayments: $setup.cobraStatements,
      title: _ctx.TransactionsHistory
    }, null, 8, ["cobraPayments", "title"])
  ]))
}